import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import ReactOutlineManager from 'react-outline-manager';
import Router from './Router';
import { LanguageContextProvider } from './utils/LanguageContext';
import content from './constants/content';
import registerServiceWorker from './registerServiceWorker';
import './styles/base.css';

ReactDOM.render(
	<LanguageContextProvider value={{ content: content.en }}>
		<StrictMode>
			<ReactOutlineManager toggle>
				<Router />
			</ReactOutlineManager>
		</StrictMode>
	</LanguageContextProvider>,
	document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js